import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const whatsappNumber = '5492664726581'; // +54 9 2664 72-6581

  const handleWhatsAppClick = (message) => {
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${whatsappNumber}?text=${encodedMessage}`, '_blank');
    setIsOpen(false);
  };

  const quickMessages = [
    {
      text: 'Consulta sobre un producto',
      message: 'Hola! Me gustaría hacer una consulta sobre un producto.',
    },
    {
      text: 'Estado de mi pedido',
      message: 'Hola! Quiero consultar sobre el estado de mi pedido.',
    },
    {
      text: 'Información de envíos',
      message: 'Hola! Necesito información sobre envíos.',
    },
    {
      text: 'Otra consulta',
      message: 'Hola! Tengo una consulta.',
    },
  ];

  return (
    <>
      {/* Popup de opciones */}
      {isOpen && (
        <div className="fixed bottom-24 right-4 md:right-6 z-50 animate-fade-in">
          <div className="bg-white rounded-lg shadow-2xl w-80 overflow-hidden">
            {/* Header */}
            <div className="bg-green-500 p-4 text-white">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                    <MessageCircle className="w-6 h-6 text-green-500" />
                  </div>
                  <div>
                    <h3 className="font-bold">Deco Home</h3>
                    <p className="text-xs opacity-90">En línea</p>
                  </div>
                </div>
                <button
                  onClick={() => setIsOpen(false)}
                  className="text-white hover:bg-green-600 rounded-full p-1 transition"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>

            {/* Body */}
            <div className="p-4 bg-gray-50">
              <div className="bg-white rounded-lg p-3 mb-4 shadow-sm">
                <p className="text-sm text-gray-700">
                  ¡Hola! 👋 <br />
                  ¿En qué podemos ayudarte?
                </p>
              </div>

              <div className="space-y-2">
                {quickMessages.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => handleWhatsAppClick(item.message)}
                    className="w-full text-left px-4 py-3 bg-white hover:bg-gray-100 rounded-lg text-sm text-gray-700 border border-gray-200 transition"
                  >
                    {item.text}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Botón flotante */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-4 md:right-6 z-50 w-14 h-14 md:w-16 md:h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 group"
        aria-label="WhatsApp"
      >
        {isOpen ? (
          <X className="w-7 h-7 md:w-8 md:h-8" />
        ) : (
          <>
            <MessageCircle className="w-7 h-7 md:w-8 md:h-8" />
            {/* Pulse animation */}
            <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping"></span>
          </>
        )}
      </button>

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default WhatsAppWidget;
